export default __webpack_public_path__ + "static/media/bootstrapfront.4d49b82b.svg";